/** Virtualizer estimate — Saved skills catalog row (name + command + description). */
export const WORKSPACE_AGENT_ACTIONS_MENU_SKILL_CATALOG_ROW_ESTIMATE_HEIGHT = 52;

/** Virtualizer estimate — catalog row with no description line. */
export const WORKSPACE_AGENT_ACTIONS_MENU_SKILL_CATALOG_ROW_NO_DESCRIPTION_ESTIMATE_HEIGHT = 36;

/** Virtualizer estimate — filtered search row (name + command on one line). */
export const WORKSPACE_AGENT_ACTIONS_MENU_SKILL_SEARCH_ROW_ESTIMATE_HEIGHT = 36;

export const estimateWorkspaceAgentActionsMenuSkillRowHeight = (
  layout: 'catalog' | 'search',
  hasDescription: boolean,
): number => {
  if (layout === 'search') {
    return WORKSPACE_AGENT_ACTIONS_MENU_SKILL_SEARCH_ROW_ESTIMATE_HEIGHT;
  }

  return hasDescription
    ? WORKSPACE_AGENT_ACTIONS_MENU_SKILL_CATALOG_ROW_ESTIMATE_HEIGHT
    : WORKSPACE_AGENT_ACTIONS_MENU_SKILL_CATALOG_ROW_NO_DESCRIPTION_ESTIMATE_HEIGHT;
};

export const WORKSPACE_AGENT_ACTIONS_MENU_SKILLS_CATALOG_LOADING_SKELETON_ROW_COUNT = 5;

export const WORKSPACE_AGENT_ACTIONS_MENU_SKILLS_SEARCH_LOADING_SKELETON_ROW_COUNT = 4;

/** Blended search skeleton rows when task hits are already shown above the skills placeholder. */
export const WORKSPACE_AGENT_ACTIONS_MENU_SKILLS_SEARCH_LOADING_SKELETON_ROW_COUNT_WHEN_TASKS_VISIBLE = 2;

/** Shown at the bottom of the catalog list while the next page loads. */
export const WORKSPACE_AGENT_ACTIONS_MENU_SKILLS_FETCH_NEXT_PAGE_SKELETON_ROW_COUNT = 2;
